import React from 'react'
import {TabView, TabPanel} from 'primereact/tabview'
import {DataTable, DataTableFilterMeta} from 'primereact/datatable'
import {Column, ColumnFilterElementTemplateOptions} from 'primereact/column'
import {Tag} from 'primereact/tag'
import {Button} from 'primereact/button'
import AddIcon from '@mui/icons-material/Add'
import {ConfirmDialog, confirmDialog} from 'primereact/confirmdialog'
import data from '../dummyData.json'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import InquiryDataTableAndActions from './InquiryDataTableAndActions'
import {Link} from 'react-router-dom'
// import 'primereact/resources/themes/lara-light-indigo/theme.css'
const titleBodyTemplate = (value) => {
  const trimmedData = {name: value.inquiryName}
  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      {/* <img alt={trimmedData.name} src={trimmedData.image} width='32' /> */}
      <span className='col'>{trimmedData.name}</span>
    </div>
  )
}

export default function ViewApplicants() {
  const rejectedApplicationActionBodyTemplate = (value) => {
    const buttonValue =
      value.applicationFormStatus === 'done' &&
      value.documentUploadStatus === 'done' &&
      value.applicationReviewStatus === 'done' &&
      value.interviewStatus === 'done'
        ? 'view'
        : 'review'
    return (
      <div className='d-flex justify-content-center align-items-center gap-2'>
        <Button
          label={buttonValue}
          rounded
          outlined
          severity='success'
          className='px-8'
          style={{
            borderRadius: '2rem',
          }}
        />
      </div>
    )
  }
  const acceptedApplicationActionBodyTemplate = (value) => {
    return (
      <div className='d-flex justify-content-center align-items-center gap-2'>
        <Button
          label='view'
          rounded
          outlined
          severity='success'
          className='px-8'
          style={{
            borderRadius: '2rem',
          }}
        />
        <Button
          label='mark exit'
          rounded
          severity='success'
          className='px-8'
          style={{
            borderRadius: '2rem',
          }}
        />
      </div>
    )
  }

  const rejectedApplicationColumns = [
    <Column
      field='inquiryName'
      body={titleBodyTemplate}
      // filterPlaceholder='Search by title'
      showFilterMenu={false}
      alignHeader='center'
      // filter
      sortable
      sortField='inquiryName'
      frozen
      header='Name'
      key='inquiryName'
    />,

    <Column
      field='inquiryDate'
      align='center'
      alignHeader='center'
      sortable
      header='Inquiry Date'
      key='date'
    />,

    <Column
      field='admissionForClass'
      // filterField='author'
      sortField='admissionForClass'
      //   alignHeader='center'
      align='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Admission for Class'
      //   body={applicationFormStatusBodyTemplate}
      key='admissionForClass'
    />,
    <Column
      field='gender'
      // filterField='author'
      sortField='gender'
      alignHeader='center'
      align='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Gender'
      //   body={documentUploadStatusBodyTemplate}
      key='gender'
    />,
    <Column
      field='dob'
      align='center'
      alignHeader='center'
      sortable
      header='Date of Birth'
      key='dob'
    />,
    <Column
      field='rejectedOn'
      align='center'
      alignHeader='center'
      sortable
      header='Rejected Date'
      key='rejectedDate'
    />,

    <Column
      header='Actions/Status'
      alignHeader='center'
      // headerClassName=''
      body={rejectedApplicationActionBodyTemplate}
      exportable={false}
      // style={{minWidth: '10rem'}}
      key='actions'
    />,
  ]
  const acceptedApplicationColumns = [
    <Column
      field='inquiryName'
      body={titleBodyTemplate}
      // filterPlaceholder='Search by title'
      showFilterMenu={false}
      alignHeader='center'
      // filter
      sortable
      sortField='inquiryName'
      frozen
      header='Name'
      key='inquiryName'
    />,

    <Column
      field='inquiryDate'
      align='center'
      alignHeader='center'
      sortable
      header='Inquiry Date'
      key='date'
    />,

    <Column
      field='admissionForClass'
      // filterField='author'
      sortField='admissionForClass'
      //   alignHeader='center'
      align='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Admission for Class'
      //   body={applicationFormStatusBodyTemplate}
      key='admissionForClass'
    />,
    <Column
      field='gender'
      // filterField='author'
      sortField='gender'
      alignHeader='center'
      align='center'
      sortable
      // filter
      showFilterMenu={false}
      showClearButton={false}
      // filterElement={authorFilterRowTemplate}
      header='Gender'
      //   body={documentUploadStatusBodyTemplate}
      key='gender'
    />,
    <Column
      field='dob'
      align='center'
      alignHeader='center'
      sortable
      header='Date of Birth'
      key='dob'
    />,
    <Column
      field='admittedOn'
      align='center'
      alignHeader='center'
      sortable
      header='Admitted Date'
      key='admittedDate'
    />,

    <Column
      header='Actions/Status'
      alignHeader='center'
      // headerClassName=''
      body={acceptedApplicationActionBodyTemplate}
      exportable={false}
      // style={{minWidth: '10rem'}}
      key='actions'
    />,
  ]
  return (
    <>
      <div className='card'>
        {/* <div className='card-header'> */}
        {/* <h3 className='card-title'> */}

        {/* </h3> */}
        {/* </div> */}
        <div className='card-body'>
          <Link to={'/Admission'}>
            <button
              className='btn btn-sm btn-icon btn-clear btn-active-light-primary me-3'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              aria-label='Back'
              data-bs-original-title='Back'
              data-kt-initialized='1'
            >
              <i className='ki-duotone ki-arrow-left fs-1 m-0'>
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
            </button>
          </Link>
          <TabView>
            <TabPanel
              header='View Inquiries'
              key='tab1'
              headerClassName='col-4 d-flex justify-content-center'
            >
              <InquiryDataTableAndActions />
              {/* <div className='d-flex justify-content-end mt-5'>
                <Button
                  label='Add Inquiry'
                  // className='mt-6'
                  rounded
                  severity='info'
                  icon={<AddIcon />}
                  style={{
                    borderRadius: '2rem',
                  }}
                  onClick={() => {
                    // setModalHeader('Add Inquiry')
                    // setVisible(true)
                  }}
                />
              </div> */}
            </TabPanel>
            <TabPanel
              header='Accepted Applications'
              key='tab2'
              headerClassName='col-4 d-flex justify-content-center'
            >
              <DataTable
                value={data.acceptedApplicationTableValues}
                showGridlines
                paginator
                rows={20}
                rowsPerPageOptions={[1, 2, 5, 10, 20, 25, 50, 100]}
                size='normal'
                tableStyle={{minWidth: '50rem'}}
                // filters={tableFilters}
                removableSort
                emptyMessage='No Rejected Applicants have been added for the selected filters.'
                paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
                currentPageReportTemplate='Showing {first} to {last} of {totalRecords} Rejected Applicants'
                scrollable
                // filterDisplay='row'
              >
                {acceptedApplicationColumns}
              </DataTable>
            </TabPanel>
            <TabPanel
              header='Rejected Applications'
              key='tab3'
              headerClassName='col-4 d-flex justify-content-center'
            >
              <DataTable
                value={data.rejectedApplicationTableValues}
                showGridlines
                paginator
                rows={20}
                rowsPerPageOptions={[1, 2, 5, 10, 20, 25, 50, 100]}
                size='normal'
                tableStyle={{minWidth: '50rem'}}
                // filters={tableFilters}
                removableSort
                emptyMessage='No Rejected Applicants have been added for the selected filters.'
                paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
                currentPageReportTemplate='Showing {first} to {last} of {totalRecords} Rejected Applicants'
                scrollable
                // filterDisplay='row'
              >
                {rejectedApplicationColumns}
              </DataTable>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </>
  )
}
